var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleTheme),attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.$store.getters.language === 'ru' && _vm.routeName !== 'RegistrationPromotion')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }